jQuery_T4NT(document).ready(function($) {

     /**
     *  Variant selection changed
     *  data-variant-toggle="{{ variant.id }}"
     */
	   $( document ).on( "variant:changed", function( evt ) {
	     // console.log( evt.currentVariant );
	     // $('[data-variant-toggle]').hide(0);
	     // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
	   });
});

const soldOutElements = document.querySelectorAll('.t4s-pr-color__item.t4s-pr-color--sold-out.t4s-tooltip-actived');
soldOutElements.forEach(async (el) => {
  if (typeof setElementStyles === 'function') {
    await setElementStyles(el, { display: 'none' });
  }
});


document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll('.variant-thumbnail').forEach(function (thumb) {
        if (thumb.dataset.inventory == "0") {
            thumb.style.display = "none";
        }
    });
});